import { z } from 'zod';

// Validate import.meta.env once at startup; fail fast on a misconfigured deploy.
const EnvSchema = z.object({
  VITE_API_BASE_URL: z.string().min(1),
  VITE_PAYMENTS_BASE_URL: z.string().min(1),
  VITE_WEB_LINK: z.string().url(),
  VITE_MEDIA_BASE_URL: z.string().url(),
  VITE_S3_BUCKET: z.string().min(1),
  VITE_ENV: z.enum(['local', 'dev', 'stg', 'pprd', 'prd']),
  VITE_CALL_LOGGING: z.enum(['true', 'false']).transform((v) => v === 'true'),
  VITE_VALIDATE_RESPONSES: z
    .enum(['true', 'false'])
    .default('false')
    .transform((v) => v === 'true'),
  // External moderation policy tools (parity with CMP BuildKonfig.coopUrl / ospreyUrl). Blank = hidden.
  VITE_COOP_URL: z
    .string()
    .default('')
    .transform((v) => v.trim()),
  VITE_OSPREY_URL: z
    .string()
    .default('')
    .transform((v) => v.trim()),
});

export const env = EnvSchema.parse(import.meta.env);
export type AppEnv = typeof env;
